var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "send" }, [
      _c("div", { staticClass: "send__holder" }, [
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.noteText,
              expression: "noteText",
            },
          ],
          staticClass: "send__area",
          style: { height: _vm.currentHeight + "px" },
          attrs: { rows: "2", placeholder: "Написать заметку ..." },
          domProps: { value: _vm.noteText },
          on: {
            keyup: function ($event) {
              return _vm.resizeHandler($event)
            },
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.noteText = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "send__btn",
            attrs: { title: "Сохранить" },
            on: { click: _vm.addNote },
          },
          [_c("i", { staticClass: "uk-icon-send" })]
        ),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "send__message" }, [
        _vm._v(
          "\n            * Вы видите только собственные заметки с ваших учетных записей. Они не видны сторонним пользователям.\n        "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { ref: "target", staticClass: "target" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }